import React, { useEffect } from "react";
import type { ComponentType } from "react";
import { connect, useSelector } from "react-redux";
import { addLog } from "../log/actionCreators";
import { loadInstalledHabits } from "./actionCreators";
import { getUserHabit } from "./selectors";
import type { Habit, UserHabit } from "./types";
import type { State } from "../store";
import { useParams } from "react-router-dom";

import type { LogEntry } from "../log/types";
export type OwnProps = {};
export type StateProps = {
  log: LogEntry<any>[] | null | undefined;
  now: number;
  time: number;
  habitId: string;
};
export type DispatchProps = {
  addLog: (arg0: LogEntry<any>) => void;
};
export type ComponentProps = StateProps &
  DispatchProps & {
    habit: Habit;
  };
export type LoadingComponentProps = StateProps &
  DispatchProps &
  OwnProps & {
    habit: Habit | null | undefined;
    loadInstalledHabits: () => void;
  };
export default function UserHabitContainer(
  ComposedComponent: ComponentType<ComponentProps>
): ComponentType<OwnProps> {
  const mapStateToProps = (state, ownProps) => {
    return {
      ...ownProps,
      time: state.time.time,
      now: state.time.now,
    };
  };

  const mapDispatchToProps = {
    addLog,
    loadInstalledHabits,
  };

  const LoadingComponent = function (props: LoadingComponentProps) {
    const { habitId } = useParams();
    const userHabit: UserHabit | null | undefined = useSelector(
      (state: State) => {
        return getUserHabit(state, habitId);
      }
    );

    const log = useSelector<State, LogEntry<any>[] | null>((state) =>
      state.log == null
        ? null
        : state.log.filter((entry) => entry.type === habitId)
    );

    const { loadInstalledHabits, ...otherProps } = props;

    useEffect(() => {
      if (userHabit == null || userHabit.habit == null) {
        loadInstalledHabits();
      }
    }, [habitId, userHabit, loadInstalledHabits]);
    if (log == null || userHabit == null || userHabit.habit == null) {
      return null;
    } else {
      return (
        <ComposedComponent
          {...otherProps}
          habit={userHabit.habit}
          log={log}
          habitId={habitId}
        />
      );
    }
  };

  return connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(LoadingComponent);
}
